import { GroupBlock } from "../../types";
import { i18nLanguage } from "i18n";
import { getLocalizedString } from "../../utils/getLocalizedString";

type CarouselGroupLabelProps = {
  group: GroupBlock | null;
  language: i18nLanguage;
};

export const CarouselGroupLabel = ({ group, language }: CarouselGroupLabelProps) => {
  if (!group) return null;

  const name = group.name
    ? getLocalizedString(group.name, language)
    : group.place?.name
      ? getLocalizedString(group.place.name, language)
      : null;

  if (!name) return null;

  return (
    <div className="tripper-carousel__group-label">
      <span>{name}</span>
    </div>
  );
};
